import { Toasts } from "@dozka/ui";

/**
 * La pile des `toaster()` de la librairie, posée UNE fois, à la racine de l'app
 * (`AppProviders`) : ce qui s'est passé, dit en passant — « Synchronisation
 * terminée », « Envoi raté » — par une pilule qui descend du haut de l'écran.
 *
 * Sans elle, un `toaster()` appelé depuis un écran n'affiche rien : la file
 * existe, personne ne la lit. Elle est montée à la racine (et non dans la
 * coque) pour répondre aussi sur la connexion, l'onboarding, la landing et la
 * doc — les écrans qui n'ont pas de coque. La pile suit le thème de l'app (elle
 * ne lit que ses jetons) et passe au-dessus des fenêtres (z-index 600).
 *
 * On appelle `toaster({ texte, sous?, ton?, duree?, action? })` de
 * `@/shared/ui`, de n'importe où : un composant, un gestionnaire d'erreur, une
 * réponse d'API. Le libellé de la croix (« Fermer ») est celui de l'app : il vient de
 * `<Libelles>` (`LibellesDeLApp`, posé plus haut dans `AppProviders`), pas d'une prop ici.
 */
export function ToastsDeLApp() {
  return <Toasts />;
}
